"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemAction = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/icon/icon");
const menu_item_styles_1 = require("@/components/common/menu-item/menu-item.styles");
const menu_item_utils_1 = require("@/components/common/menu-item/menu-item.utils");
const shared_styles_1 = require("@/stylesheets/shared.styles");
let MenuItemAction = class MenuItemAction extends (0, menu_item_utils_1.withMenuItemPresentation)(lit_1.LitElement) {
    constructor() {
        super(...arguments);
        this.disabled = false;
    }
    render() {
        return (0, lit_1.html) `
      <button type="button" role="menuitem" ?disabled=${this.disabled}>
        ${(0, menu_item_utils_1.renderMenuItemContent)(this, this.renderTrailing())}
      </button>
    `;
    }
    renderTrailing() {
        if (!this.trailingIcon) {
            return (0, lit_1.html) `
        <slot name="trailing" slot="trailing"></slot>
      `;
        }
        return (0, lit_1.html) `
      <mm-icon slot="trailing" name=${this.trailingIcon}></mm-icon>
    `;
    }
};
MenuItemAction.styles = [shared_styles_1.resetStyles, menu_item_styles_1.menuItemStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'trailing-icon' })
], MenuItemAction.prototype, "trailingIcon", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], MenuItemAction.prototype, "disabled", void 0);
MenuItemAction = __decorate([
    (0, decorators_js_1.customElement)('mm-menu-item-action')
], MenuItemAction);
exports.MenuItemAction = MenuItemAction;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVudS1pdGVtLWFjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm1lbnUtaXRlbS1hY3Rpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQXNDO0FBQ3RDLHFEQUEyRDtBQUUzRCx5Q0FBc0M7QUFHdEMscUZBQStFO0FBQy9FLG1GQUdzRDtBQUN0RCwrREFBeUQ7QUFHbEQsSUFBTSxjQUFjLEdBQXBCLE1BQU0sY0FBZSxTQUFRLElBQUEsMENBQXdCLEVBQUMsZ0JBQVUsQ0FBQztJQUFqRTs7UUFHd0IsYUFBUSxHQUFHLEtBQUssQ0FBQTtJQXFCL0MsQ0FBQztJQW5CQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTt3REFDeUMsSUFBSSxDQUFDLFFBQVE7VUFDM0QsSUFBQSx1Q0FBcUIsRUFBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLGNBQWMsRUFBRSxDQUFDOztLQUV2RCxDQUFBO0lBQ0gsQ0FBQztJQUVPLGNBQWM7UUFDcEIsSUFBSSxDQUFDLElBQUksQ0FBQyxZQUFZLEVBQUU7WUFDdEIsT0FBTyxJQUFBLFVBQUksRUFBQTs7T0FFVixDQUFBO1NBQ0Y7UUFFRCxPQUFPLElBQUEsVUFBSSxFQUFBO3NDQUN1QixJQUFJLENBQUMsWUFBWTtLQUNsRCxDQUFBO0lBQ0gsQ0FBQzs7QUF0Qk0scUJBQU0sR0FBRyxDQUFDLDJCQUFXLEVBQUUsaUNBQWMsQ0FBQyxDQUFBO0FBQ1c7SUFBdkQsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsZUFBZSxFQUFFLENBQUM7b0RBQXdCO0FBQ2xEO0lBQTVCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsQ0FBQztnREFBaUI7QUFIbEMsY0FBYztJQUQxQixJQUFBLDZCQUFhLEVBQUMscUJBQXFCLENBQUM7R0FDeEIsY0FBYyxDQXdCMUI7QUF4Qlksd0NBQWMifQ==